import React from 'react';
import { PaginationState, calculatePageRange } from '.';
import { range } from 'lodash';

interface PaginationProps {
    value: PaginationState;
    showFirstLastButtons?: boolean;
    showPreviousNextButtons?: boolean;
    pagesToDisplay?: number;
}

const Pagination: React.FC<PaginationProps> = ({ value, pagesToDisplay = 7 }) => {
    // const startPage = Math.max(0, value.currentPage - (pagesToDisplay - 1) / 2);
    // const endPage = Math.max(0, value.currentPage + (pagesToDisplay - 1) / 2);

    const pageRange = calculatePageRange(value.currentPage, value.numberOfPages, pagesToDisplay);
    const pages = range(pageRange.start, pageRange.end + 1);

    return (
        <div>
            <div>
                Showing&nbsp;
                <strong>
                    {value.displayedEntries.start + 1} to {Math.min(value.displayedEntries.end + 1, value.totalEntries)} of{' '}
                    {value.totalEntries}&nbsp;
                </strong>
                entries
            </div>

            <div>
                <button onClick={(e) => value.setPage(0)}>&lt;&lt;</button>
                <button onClick={(e) => value.setPage(value.currentPage - 1)}>&lt;</button>
                {pages.map((i) => (
                    <button
                        onClick={(e) => value.setPage(i)}
                        key={i}
                        className={i === value.currentPage ? 'active' : undefined}>
                        {i + 1}
                    </button>
                ))}
                <button onClick={(e) => value.setPage(value.currentPage + 1)}>&gt;</button>
                <button onClick={(e) => value.setPage(value.numberOfPages - 1)}>&gt;&gt;</button>
            </div>
        </div>
    );
};

export default Pagination;
